import * as React from "react";

/**
 * The bridge ids of the audiences the line item being edited has SAVED, for
 * the picker's `includeIds` (see `savedAudiences.ts`).
 *
 * A context rather than a prop: the picker query sits six components below the
 * edit screen, behind the targeting form that targeting presets share, and
 * presets carry no audiences. Anything without a provider — line-item create,
 * the preset form — reads the empty default and never lists a paused audience.
 */
const SavedAudienceIdsContext = React.createContext<number[]>([]);

export function SavedAudienceIdsProvider({
  ids,
  children,
}: {
  ids: number[];
  children: React.ReactNode;
}) {
  return (
    <SavedAudienceIdsContext.Provider value={ids}>
      {children}
    </SavedAudienceIdsContext.Provider>
  );
}

export function useSavedAudienceIds() {
  return React.useContext(SavedAudienceIdsContext);
}
